import type { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { indentLegacyDefaultV0Schema } from './default';

export type LegacyIndent = z.infer<typeof indentLegacyDefaultV0Schema>;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet).
 * Single placement, like line/accordion/logo — no envelope union.
 */
export const LegacyIndentEntitySchema = createLegacyEntitySchema([
    { name: 'web', schema: indentLegacyDefaultV0Schema },
]);
